import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';

const EmptyRoutes = ({
  component: Component,
  HeaderMenu,
  headerMenuStyles,
  useMobileLayout,
  ...rest
}) => (
  <Route
      // eslint-disable-next-line react/jsx-props-no-spreading
    {...rest}
    render={(props) => (
      <>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <Component {...props} />
      </>
    )}
  />
);

EmptyRoutes.defaultProps = {
  useMobileLayout: false,
};

EmptyRoutes.propTypes = {
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.object]).isRequired,
  HeaderMenu: PropTypes.oneOfType([PropTypes.node, PropTypes.object]).isRequired,
  headerMenuStyles: PropTypes.string.isRequired,
  useMobileLayout: PropTypes.bool,
};

export default EmptyRoutes;
